import { useEffect, useState } from 'react';
import '../styles/Topbar.css'
import { FaBars, FaSun } from "react-icons/fa";
import Logo from './Logo';
import { useTheme } from '../hooks/ThemeContext';
import React from 'react';
import LogoPlatform from './LogoPlatform';


type Props = {
    children?: React.ReactNode;
    setActiveUserId: any,
    setSidebarOpen: any,
    showSidebarToggle: boolean,
    borderBottom?: string,
    height?: string,
    mobileBottomBar?: boolean,
    logo?: string,
    hideLogo?: boolean
}

const Topbar = (props: Props) => {

    useEffect(()=> {
        console.log("ibearoifrwj")
        console.log(props.logo)
        console.log(props.hideLogo)
    }, [props.logo])

    const { theme } = useTheme();

    const onHamburgerClick = () => {
        props.setSidebarOpen((currentStatus: boolean) => !currentStatus);
    }

    // Logo click = the brand's home: /r/{appId} when the URL carries it
    // (shared-host proxy), otherwise the host root — which covers custom
    // domains and any future DinePlatform hostnames.
    let redirect = "/";
    const brandBase = window.location.pathname.match(/^\/r\/[^/]+/);
    if (brandBase) redirect = brandBase[0];

    if (props.logo === "platform" || props.logo === "platformLight") {
        redirect = "https://dineplatform.com"
    }


    return (
        <div className="top-bar" style={{backgroundColor: theme.topbarBackgroundColor, borderBottom: `1px solid ${theme.topbarBorderBottomColor}` || "1px solid rgb(218,218,218)", height: props.height || "auto", color: theme.topbarIconColor || "black", userSelect: "none"}}>
            <div className="top-bar-inner">
            <div className="hamburger-logo-container" style={{width: "50%"}}>
                {props.showSidebarToggle && <div className={`topbar-icon ${props.mobileBottomBar ? "hide-mobile" : ""}`} style={{color: theme.topbarIconColor}} onClick={onHamburgerClick}><FaBars /></div>}
                {!props.showSidebarToggle && <span style={{marginLeft: "5px", height: "1px", float: "left"}}></span>}
                <div className="logo-container" onClick={() => {window.location.replace(redirect)}}>
                    {props.logo !== "platform" && props.logo !== "platformLight" && <Logo useCachedLogo={props.hideLogo}/>}
                    {props.logo === "platformLight" && !props.hideLogo && <LogoPlatform light />}
                    {props.logo === "platform" && !props.hideLogo && <LogoPlatform />}
                </div>
            </div>

            <div className="options-container" style={{color: theme.topbarIconColor}}>
                {props.children}
            </div>
            </div>
            
        </div>

    )
}

export default Topbar;